module.exports = __webpack_public_path__ + "img/back_top.b0216074.gif";